import { parseDate } from '@chakra-ui/react';

/** Two-digit zero-pad for a calendar part. */
const pad = (value: number) => String(value).padStart(2, '0');

/** Calendar parts → ISO `yyyy-mm-dd` (the value the API expects). */
export const toIsoDate = (year: number, month: number, day: number) => `${year}-${pad(month)}-${pad(day)}`;

/** Calendar parts → `DD/MM/YYYY` for display in a date input. */
export const formatDisplayDate = (year: number, month: number, day: number) => `${pad(day)}/${pad(month)}/${year}`;

/** Parse a `DD/MM/YYYY` string into a Chakra DateValue, or undefined if malformed. */
export const parseDisplayDate = (input: string) => {
	const match = input.trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
	if (!match) return undefined;
	const [, dd, mm, yyyy] = match;
	try {
		return parseDate(`${yyyy}-${mm.padStart(2, '0')}-${dd.padStart(2, '0')}`);
	} catch {
		return undefined;
	}
};
